export function stripTrailingSlash(url) {
    return url?.replace(/\/$/, "");
}
//# sourceMappingURL=url.js.map